import {useInView} from "react-intersection-observer";
import {useFetchOffers} from "../../../hooks/useOffers";
import {useMe} from "../../../hooks/useGetUser";
import {userRoleList} from "../../../utils/constants";
import newPost from "../../../images/newPost.png";
import {Link} from "react-router-dom";
import {useChatRooms} from "../../../hooks/useChat";
import Loader from "../../components/shared/Loader";
import ImageComponent from "../../components/shared/ImageComponent";
import {useDailyIntervention} from "../../../hooks/useInterventions";
import {InterventionCardClient, InterventionCardTech} from "./interventionCard";
import {useGetCatgeory} from "../../../hooks/useCategory";
import {useMemo} from "react";
import {DateGroupedIntervention} from "../../../utils/date";
import QueryErrorState from "../../components/shared/QueryErrorState";
import EmptyState from "../../components/shared/EmptyState";

const ListCardIntervention = ({filter}) => {
  const {data, isLoading: isMeLoading} = useMe();
  const {
    data: chatrooms,
    isLoading: ischatloading,
    isError: ischatEroor,
  } = useChatRooms();
  const {interventions, isError, error, isLoading, refetch} = useDailyIntervention({
    ...filter,
  });

  const {data: categories, isLoading: isCategoryLoading} = useGetCatgeory();

  const groupByStartDate = (interventions) => {
    return interventions.reduce((groups, intervention) => {
      const startDate = DateGroupedIntervention(intervention.startDate);
      const chatId = chatrooms.find(
        (chat) => chat?.offerId === intervention?.Offer_Proposal?.Offer?.id
      )?.id; // Ensure pubDate is properly formatted
      if (!groups[startDate]) {
        groups[startDate] = [];
      }
      groups[startDate].push({...intervention, chatId});
      return groups;
    }, {});
  };
  const groupedInterventions = useMemo(() => {
    if (interventions && chatrooms) {
      return groupByStartDate(interventions);
    } else {
      return [];
    }
  }, [interventions, chatrooms]);

  if (isLoading || isMeLoading || ischatloading || isCategoryLoading) {
    return <Loader />;
  }

  if (isError || ischatEroor) {
    return <QueryErrorState error={error} onRetry={refetch} />;
  }
  return (
    <>
      {interventions?.length === 0 && (
        <EmptyState className="w-full min-h-[70vh] p-6 bg-white rounded-2xl border border-solid border-[#E2E2E2]" />
      )}

      {Object.entries(groupedInterventions).map(([pubDate, interventions]) => (
        <div key={pubDate} className="mb-4 flex flex-col w-full gap-3">
          <div className="text-[14px] leading-4 font-medium  text-[#19295C] ">
            {pubDate}
          </div>
          {interventions.map((intervention, index) => (
            <div className="w-full" key={index}>
              <InterventionCardClient
                categories={categories}
                intervention={intervention}
              />
            </div>
          ))}
        </div>
      ))}
    </>
  );
};

export default ListCardIntervention;
